import {
  CANNOT_CONTAIN_DICTIONARY_WORDS,
  CANNOT_CONTAIN_OLD_PASSWORDS,
  PASSWORD_DICTIONARY_ERROR_MESSAGE,
  PASSWORD_UNSECURE_ERROR_MESSAGE,
  UNSECURE_PASSWORD,
  USERNAME_ALREADY_EXISTS,
  USER_NAME_ALREADY_EXIST_ERROR_MESSAGE,
  USER_TYPE_CONSUMER,
  VALID_PASSWORD,
} from "../../../Constants/AccountSetupConstants";
import {
  API_ACTION_VALIDATE,
  API_ACTION_VERIFY,
  RESPONSE_CODE_406,
} from "../../../Constants/CommonConstants";
import {
  THUNK_POST_PASSWORD,
  THUNK_POST_USERNAME,
} from "../../../Constants/SliceAndThunkConstants";
import {
  clearAccountCreationApiResponse,
  postPassword,
  postUsername,
} from "../../../Features/AccountCreationSlice";
import { fetchResponseCodeAndDescription } from "../../../Services/CommonServices";

const passwordSuccessStatus = (passwordApiResponse) => {
  const passedValidations = [];
  if (
    passwordApiResponse === VALID_PASSWORD ||
    passwordApiResponse === UNSECURE_PASSWORD ||
    passwordApiResponse === CANNOT_CONTAIN_OLD_PASSWORDS
  ) {
    passedValidations.push(PASSWORD_DICTIONARY_ERROR_MESSAGE);
  }
  return passedValidations;
};

const passwordErrorStatus = (passwordApiResponse) => {
  if (passwordApiResponse === CANNOT_CONTAIN_DICTIONARY_WORDS) {
    return PASSWORD_DICTIONARY_ERROR_MESSAGE;
  } else if (passwordApiResponse === UNSECURE_PASSWORD) {
    return PASSWORD_UNSECURE_ERROR_MESSAGE;
  }
  return null;
};

export const verifyUsernameResponse = async (value, dispatch) => {
  const response = await dispatch(
    postUsername({
      data: { userName: value },
      apiAction: API_ACTION_VERIFY,
    })
  );
  dispatch(clearAccountCreationApiResponse(THUNK_POST_USERNAME));

  const { code, description } = fetchResponseCodeAndDescription(response);

  if (code === RESPONSE_CODE_406 && description === USERNAME_ALREADY_EXISTS) {
    return USER_NAME_ALREADY_EXIST_ERROR_MESSAGE;
  }
  return null;
};

export const validatePasswordResponse = async (
  value,
  dispatch,
  userNameValue
) => {
  const response = await dispatch(
    postPassword({
      data: {
        userName: userNameValue,
        password: value,
        fpactUserType: USER_TYPE_CONSUMER,
      },
      apiAction: API_ACTION_VALIDATE,
    })
  );
  dispatch(clearAccountCreationApiResponse(THUNK_POST_PASSWORD));

  const { description } = fetchResponseCodeAndDescription(response);

  const errorResponse = passwordErrorStatus(description);
  const successResponse = passwordSuccessStatus(description);

  return { errorResponse, successResponse };
};
